module.exports = __webpack_public_path__ + "img/refer-a-friend-banner.13c086a4.png";